export default __webpack_public_path__ + "static/media/Mapa_federal.b8db385b.svg";